import { jsxs as v, jsx as n } from "../../_virtual/jsx-runtime.mjs";
import * as l from "react";
import { fontColor as p } from "../../assets/css/color.mjs";
import { loopIconWrap as I, loopIcon as u } from "./css/ReoAccordion.mjs";
import d from "./Circle.mjs";
import z from "../ReoIcon/ReoIcon.mjs";
import a from "../../depend/classnames/index.mjs";
import { suffixPx as s } from "../../utils/suffixPx.mjs";
import { defaultProps as t } from "./const.mjs";
const j = (o) => {
  var i, r;
  const m = l.useMemo(() => ({
    animationDuration: `${o.loopGap}s`
  }), [o.loopGap]), C = l.useMemo(
    () => {
      var c, e;
      return {
        "--circle-color": o.loopIconCircleColor,
        width: s(((c = o.loopSize) == null ? void 0 : c.iconCircle) ?? 32),
        height: s(((e = o.loopSize) == null ? void 0 : e.iconCircle) ?? 32)
      };
    },
    [o.loopIconCircleColor, o.loopSize]
  ), f = l.useMemo(() => o.active ? o.loopIconActiveColor ?? p.normal500 : o.loopIconColor ?? p.normal500, [o.active, o.loopIconActiveColor, o.loopIconColor]);
  return /* @__PURE__ */ v(
    "div",
    {
      style: C,
      className: a(I, o.loopIconCircleClassName),
      children: [
        o.active ? /* @__PURE__ */ n(
          d,
          {
            activeColor: o.loopIconCircleActiveColor,
            color: o.loopIconCircleColor,
            style: m,
            size: ((i = o.loopSize) == null ? void 0 : i.iconCircle) ?? t.loopSize.iconCircle
          }
        ) : null,
        /* @__PURE__ */ n(
          z,
          {
            className: a(u, o.loopIconClassName),
            color: f,
            width: ((r = o.loopSize) == null ? void 0 : r.icon) ?? t.loopSize.icon,
            name: "icon-icon_arrow-down"
          }
        )
      ]
    }
  );
};
export {
  j as LoopIcon
};
//# sourceMappingURL=Icons.mjs.map
